import { Box } from '@mui/material';
import { memo } from 'react';

function Eye() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} data-testid="eye">
      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.96466 5.99994C8.96466 7.08515 8.08492 7.96489 6.99971 7.96489C5.91449 7.96489 5.03475 7.08515 5.03475 5.99994C5.03475 4.91472 5.91449 4.03498 6.99971 4.03498C8.08492 4.03498 8.96466 4.91472 8.96466 5.99994Z"
          stroke="white"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 5.99991C1.58463 3.34258 4.06721 1.41504 6.99999 1.41504C9.93279 1.41504 12.4154 3.34261 13.25 5.99996C12.4154 8.65729 9.93279 10.5848 7.00001 10.5848C4.06721 10.5848 1.58462 8.65727 0.75 5.99991Z"
          stroke="white"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
}

export default memo(Eye);

export const EyeSmall = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0717 7.99995C10.0717 8.86812 9.36794 9.57191 8.49976 9.57191C7.63159 9.57191 6.9278 8.86812 6.9278 7.99995C6.9278 7.13178 7.63159 6.42798 8.49976 6.42798C9.36794 6.42798 10.0717 7.13178 10.0717 7.99995Z"
        stroke="#374151"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 7.99993C4.1677 5.87406 6.15377 4.33203 8.49999 4.33203C10.8462 4.33203 12.8323 5.87408 13.5 7.99997C12.8323 10.1258 10.8462 11.6679 8.50001 11.6679C6.15377 11.6679 4.16769 10.1258 3.5 7.99993Z"
        stroke="#374151"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Box>
);
